<template>
  <div class="page-container">
    <div v-if="computedTitle" class="page-header">
      <div class="title">
        <slot name="title">
          {{ computedTitle }}
          <icon-question-circle
            v-if="showInfoIcon"
            class="icon"
            @click.native="emit('iconClicked')"
          />
        </slot>
      </div>
      <div class="right-area"><slot name="right" /></div>
    </div>

    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script setup>
import { findLast } from 'lodash-es';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const props = defineProps({
  title: { type: String },
  showInfoIcon: { type: Boolean },
});

const emit = defineEmits(['iconClicked']);

const { t } = useI18n();
const route = useRoute();

const computedTitle = computed(() => {
  if (props.title !== undefined) return props.title;

  const menuRoute = findLast(route.matched, (r) => r.meta?.menu);
  return menuRoute?.meta?.langKey ? t(menuRoute.meta.langKey) : '';
});
</script>

<style lang="less" scoped>
.page-container {
  .page-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    margin-bottom: 18px;

    .title {
      font-weight: bold;
      font-size: 20px;
      line-height: 28px;
      color: var(--color-text-1);
      .icon {
        vertical-align: middle;
        cursor: pointer;
      }

      &:empty {
        display: none;
      }
    }
    .right-area {
      padding: 0 16px;
    }
    :deep {
      .arco-link {
        color: var(--color-text-3, #86909c);
      }
      .arco-space-item {
        margin: 0 8px !important;
      }
      .arco-space-item-split {
        margin: 0 !important;
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .page-container {
    .title {
      .padding-left(16px);
    }
    .page-header {
      .right-area {
        padding: 0 8px;
      }
    }

    :deep {
      .arco-divider-vertical {
        margin: 0 2px;
      }
    }
  }
}
</style>
